<template>
  <div v-if="item.customFields.length > 0">
    <hr>
    <div v-show="!isRoleDisabled(customField)" v-for="(customField, index) in item.customFields" v-bind:key="index">
      <p v-if="customField.label && customField.type === 'datetime'"><b>{{customField.label}}: </b><span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
      <p v-else-if="customField.name &&customField.type === 'datetime'"><b>{{customField.name}}: </b><span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
      <p v-else-if="customField.type === 'multiSelect' && customField.value.length > 0"><b>{{customField.label}}: </b><span v-if="customField.value.length > 0">{{customField.value.join(', ')}}</span><span v-else>{{$t('null')}}</span></p>
      <p v-else-if="customField.type === 'inputFormatted'"><b>{{customField.label}}: </b><span v-html="customField.value"></span></p>
      <items-collection-custom-field-values v-else-if="customField.type === 'itemsCollection'" :data="customField"></items-collection-custom-field-values>
      <id-user-data-custom-field-value v-else-if="customField.type === 'idUserData'" :data="customField"></id-user-data-custom-field-value>
      <p v-else-if="customField.label && customField.value"><b>{{customField.label}}: </b>{{(customField.value)}}</p>
      <p v-else-if="customField.name && customField.value"><b>{{customField.name}}: </b>{{(customField.value)}}</p>
    </div>
  </div>
</template>
<script>
import { getUserRoles } from '@/utils/checkRoles'
import ItemsCollectionCustomFieldValues from '@/components/Dashboard/Views/excmcase/components/itemsCollectionCustomFieldValues.vue'
import IdUserDataCustomFieldValue from '@/components/Dashboard/Views/excmcase/components/idUserDataCustomFieldValue.vue'

export default {
  name: 'TaskExistingCustomFields',
  components: { IdUserDataCustomFieldValue, ItemsCollectionCustomFieldValues },
  props: {
    item: {}
  },
  methods: {
    isRoleDisabled (customField) {
      if (customField.disabledRoles && customField.disabledRoles.length > 0) {
        let idClientType = getUserRoles().id_client_type
        if (customField.disabledRoles.includes(idClientType)) {
          return true
        }
      }
      return false
    }
  }
}
</script>
